import $ from 'jquery';

export const getSprinkles = () => {
    const $sprinkleEls = $('[data-react]');
    const sprinkles = [];

    $sprinkleEls.each((index, sprinkleEl) => {
        const componentName = $(sprinkleEl).data('react');
        const componentProps = $(sprinkleEl).data('reactProps');

        sprinkles.push({ componentName, componentProps, sprinkleEl });
    });

    return sprinkles;
};
